import { DimensionType } from "../../types";
import type { IBulkExportStep } from "./BulkExportStepper.types";

export const virtualConfiguration: IBulkExportStep = {
  identifier: "virtual.configuration",
  hierarchyIdentifier: "virtual.configuration",
  name: "Configuration",
  type: DimensionType.Configuration,
  visible: true,
  virtual: true,
};

export const virtualFrequency: IBulkExportStep = {
  identifier: "",
  hierarchyIdentifier: "virtual.frequency",
  name: "Data frequency",
  type: DimensionType.Frequency,
  visible: true,
  virtual: true,
};

export const dynamicDateRangeTypes = [
  DimensionType.DynamicDateRangeAQM,
  DimensionType.DynamicDateRangeAQMW,
  DimensionType.DynamicDateRangeAnnual,
  DimensionType.DynamicDateRangeWeek,
];

export const compareExeptions = ["calendar.default", "virtual.frequency", "unit_name.default", "base_index.default", "sources.default"];
